import { put, call, takeLatest } from 'redux-saga/effects';

import {
  experienceFormSetSending,
  FORM_SEND
  } from 'src/app/redux/actions/registration/experience/experienceForm';
import registrationApi from 'src/app/api/registrationApi';
import { apiExperienceError } from 'src/app/redux/actions/apiError';
import { MAILBOX_STEP, setStep } from 'src/app/redux/actions/registration/registration';


const prepareForm = (payload) => {
  const { job,
    employer,
    dateFrom,
    dateTo,
    stillWorking,
    hasWorkExperience,
    countryId,
    city
  } = payload;


  return {
    actualJobPosition: job,
    companyName: employer,
    actualPositionBeginDate: dateFrom,
    actualPositionEndDate: dateTo,
    userIsStillWorking: stillWorking,
    userHasWorkExperience: hasWorkExperience,
    residenceCity: city,
    countryId
  };
};


function sendExperienceForm(transformPayload, requestMethod) {
  return function* sendExperienceFormGenerator({ payload }) {
    const { userId } = payload;
    const body = transformPayload(payload);

    yield put(experienceFormSetSending(true));

    const request = yield requestMethod(body, userId)
      .then(function* onSuccess() {
        return yield put(setStep(MAILBOX_STEP));
      })
      .catch(function* onError({ response }) {
        yield put(experienceFormSetSending(false));
        return yield put(apiExperienceError(response));
      });


    yield call(() => request);
  };
}

export default [
  takeLatest(FORM_SEND, sendExperienceForm(prepareForm, registrationApi.sendExperienceForm))
];
